import * as types from '../const/action.types';

export function local(state = {}, action) {
    switch (action.type) {
        case types.LOAD_LOCAL_SUCCESS:
            return action.data;
        default:
            return state;
    }
}

export function localInfo(state = {}, action) {
    switch (action.type) {
        case types.LOAD_LOCAL_INFO_SUCCESS:
            return action.data;
        default:
            return state;
    }
}

export function localsInfo(state = [], action) {
    switch (action.type) {
        case types.LOCALS_INFO_SUCCESS:
            return action.data;
        default:
            return state;
    }
}

export function locals(state = [], action) {
    switch (action.type) {
        case types.LOCALS_SUCCESS:
            return action.data;
        default:
            return state;
    }
}

export function localsHasErrored(state = { hasErrored: false, error: '' }, action) {
    switch (action.type) {
        case types.LOCALS_HAS_ERROR:
            return {
                hasErrored: action.hasErrored,
                error: action.error,
            };

        default:
            return state;
    }
}

export function localsIsLoading(state = false, action) {
    switch (action.type) {
        case types.LOCALS_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/locals.reducer.js